// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHoldDto
 */
export interface IHoldDto {
    /**
     * 
     * @type {string}
     * @memberof IHoldDto
     */
    type?: IHoldDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IHoldDto
     */
    status?: IHoldDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IHoldDto
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IHoldDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IHoldDto
     */
    available_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IHoldDto
     */
    available_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IHoldDto
     */
    posting_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IHoldDto
     */
    released_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IHoldDto
     */
    account_balance_type?: IHoldDtoAccountBalanceTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IHoldDto
     */
    release_blockers?: Array<IHoldDtoReleaseBlockersEnum>;
}

/**
* @export
* @enum {string}
*/
export enum IHoldDtoTypeEnum {
    STANDARD = 'STANDARD',
    MANUAL = 'MANUAL'
}
/**
* @export
* @enum {string}
*/
export enum IHoldDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    RELEASED = 'RELEASED',
    FAILED = 'FAILED'
}
/**
* @export
* @enum {string}
*/
export enum IHoldDtoAccountBalanceTypeEnum {
    AVAILABLE_BALANCE = 'AVAILABLE_BALANCE',
    LIVE_BALANCE = 'LIVE_BALANCE'
}
/**
* @export
* @enum {string}
*/
export enum IHoldDtoReleaseBlockersEnum {
    CIP = 'CIP',
    PENDING_PAYMENT = 'PENDING_PAYMENT'
}


/**
 * Check if a given object implements the IHoldDto interface.
 */
export function instanceOfIHoldDto(value: object): value is IHoldDto {
    return true;
}

export function IHoldDtoFromJSON(json: any): IHoldDto {
    return IHoldDtoFromJSONTyped(json, false);
}

export function IHoldDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHoldDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'id': json['id'] == null ? undefined : json['id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'available_at': json['available_at'] == null ? undefined : (new Date(json['available_at'])),
        'available_amount': json['available_amount'] == null ? undefined : json['available_amount'],
        'posting_id': json['posting_id'] == null ? undefined : json['posting_id'],
        'released_at': json['released_at'] == null ? undefined : (new Date(json['released_at'])),
        'account_balance_type': json['account_balance_type'] == null ? undefined : json['account_balance_type'],
        'release_blockers': json['release_blockers'] == null ? undefined : json['release_blockers'],
    };
}

export function IHoldDtoToJSON(json: any): IHoldDto {
    return IHoldDtoToJSONTyped(json, false);
}

export function IHoldDtoToJSONTyped(value?: IHoldDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'status': value['status'],
        'id': value['id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'available_at': value['available_at'] == null ? undefined : ((value['available_at']).toISOString()),
        'available_amount': value['available_amount'],
        'posting_id': value['posting_id'],
        'released_at': value['released_at'] == null ? undefined : ((value['released_at']).toISOString()),
        'account_balance_type': value['account_balance_type'],
        'release_blockers': value['release_blockers'],
    };
}

